import {FC} from "react";
import { useTranslation } from "react-i18next";
import ListComponent from "src/app/components/list/NewList";
import { Billing } from "../models/billingModel.v2";
import billingColumns from "../components/column";
import { PageLink, PageTitle } from "src/app/layout/core";

// billing list component extending React.FC
const BillingList: FC = () => {
    const { t } = useTranslation();
    // Breadcrumb page
    const crumbs: Array<PageLink> = [
    {
        title: t("Menu.Order"),
        path: "#",
        isSeparator: false,
        isActive: false,
    },
    {
        title: "",
        path: "",
        isSeparator: true,
        isActive: false,
    },
    ];
    return (
        <>
            <PageTitle breadcrumbs={crumbs}>
                {t("OrderList.Title")}
            </PageTitle>

        <ListComponent<Billing>
            collection="billings"
            collectionGroup={false}
            columns={billingColumns}
            selection={{
                rowSelection: false,
                headerSelection: true,
                }} 
            defaultFilters={[
                {
                    field: 'isActive',
                    value: true,
                    label: '',
                    type: 'boolean'
                }
            ]}
            defaultSorting={[
              { field: "createdAt", label: "Dibuat Pada", direction: "asc" },
            ]}
            searching={{
                field: "invoiceNumber",
                useFirestore: true,
                value: "",
                caseSensitive: true,
            }}
            useFilter={[]}
            extra={[]}
            
        />

    </>
    );
    
    }

export default BillingList;


